export default __webpack_public_path__ + "static/media/Frame 6825.63811d37.png";